import { MerchantEventDetailsDto } from "@admin_api/models/merchant-event-details-dto";

export class EventState {
    loading = false;
    error = null;
    record: MerchantEventDetailsDto = null;
}
